import { Injectable } from '@angular/core';
import { GeneralHttpService } from 'src/app/shared/general-http.service';
import { TipoCategoria } from './tipo-categoria.model';


@Injectable({
  providedIn: 'root'
})
export class TipoCategoriaService {
  listTipoCat:TipoCategoria[];
  tipoCat:TipoCategoria;
  private routeApi = "AdmTipoCategorias";
  constructor(
    private generalHttp:GeneralHttpService
  ) { }

    getTipoCa(){
      return this.generalHttp.getHttp(this.routeApi).then(r=> this.listTipoCat = r as TipoCategoria[] );
    }

    putTipoCat(form:TipoCategoria,id:number){
      return this.generalHttp.putHttp(form,id,this.routeApi);
    }

}
